var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 324,
    viewBox: "0 0 400 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4101 210.497H42.1001V294.697H88.4101V210.497Z",
    stroke: "#364A43",
    strokeWidth: 2.47647
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.56 168.397H105.25V294.697H151.56V168.397Z",
    stroke: "#364A43",
    strokeWidth: 2.47647
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.71 126.297H168.4V294.697H214.71V126.297Z",
    stroke: "#364A43",
    strokeWidth: 2.47647
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.86 84.1968H231.55V294.697H277.86V84.1968Z",
    stroke: "#364A43",
    strokeWidth: 2.47647
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.01 42.0969H294.7V294.697H341.01V42.0969Z",
    stroke: "#364A43",
    strokeWidth: 2.47647
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.05 273.647L378.9 42.0969",
    stroke: "#364A43",
    strokeWidth: 2.47647
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M357.85 63.1469L378.9 42.0969L357.85 21.0469",
    stroke: "#364A43",
    strokeWidth: 2.47647
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.e78668fb2285ee2fa7a17673c268baf6.svg";
export { ForwardRef as ReactComponent };